/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const params = z.strictObject({
  serviceType: ZodTypes.ServiceType,
});

export const GetPlans = {
  id: 'plans.get',
  tag: 'Product',
  summary: 'Get product plans',
  description: 'Retrieves available plans.',
  method: 'get',
  route: (args: z.infer<typeof params>) => `/service/${args.serviceType}/plan`,
  request: { params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            compute: z.array(
              z.strictObject({
                id: ZodTypes.Id,
                name: z.string().min(1),
                serviceType: ZodTypes.ServiceType,
                cpu: z.number().min(0),
                memory: z.number().min(0),
                replicaMin: z.number().min(0),
                replicaMax: z.number().min(0),
                replicaDefault: z.number().min(0),
                isDefault: z.boolean(),
                isVisible: z.boolean(),
              }),
            ),
            storage: z.array(
              z.strictObject({
                id: ZodTypes.Id,
                name: z.string().min(1),
                serviceType: ZodTypes.ServiceType,
                size: z.number().min(0),
                storageClass: z.strictObject({
                  id: z.string(),
                  isDefault: z.boolean(),
                }),
                isDefault: z.boolean(),
                isVisible: z.boolean(),
              }),
            ),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
